import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CustomerDisplayData,
  EventCardInfo,
  PaginatorArgs,
  PaginatorCallback,
} from "../../types";
import { actions, RootState } from "../../state/reducer";
import { EventListRequestParams } from "../../forms/filters/event";
import { eventBackend } from "../../services";
import { toast } from "sonner";
import EventListCard from "../../components/events/eventCard";
import Paginator from "../../components/paginator";
import PanelSubHeading from "../../components/panel/subHeading";
import { closeModal, openModal } from "../../state/modalSlice";
import CreateEventModal from "../../modals/event/createEvent";
import { generateRandomString } from "../../utils";
import { defPageSize } from "../../constants/events";

interface ClientEventsPanelProps {
  data: CustomerDisplayData;
}

const ClientEventsPanel: React.FC<ClientEventsPanelProps> = ({ data }) => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  const [eventCards, setEventCards] = useState<EventCardInfo[]>([]);
  const [eventsCount, setEventsCount] = useState(0);
  const [paginatorInfo, setPaginatorInfo] = useState<PaginatorArgs>({
    page: 0,
    perPage: defPageSize
  })
  const session = State.session;

  useEffect(() => {
    if (!session) return;
    const filters: EventListRequestParams = {
      status_ids: [1, 2, 3],
      customer_id: Number(data.id),
      order_param: "date_start",
      order_dir: "DESC",
      offset: paginatorInfo.page * paginatorInfo.perPage,
      limit: paginatorInfo.perPage
    };
    dispatch(actions.eventRequestParams(filters));
    eventBackend
    .getEventCards(session.id, filters)
    .then((res) => {
      setEventCards(res.events);
    })
    .catch((e) => {
      toast("Не удалось загрузить события");
    });
    eventBackend.getAllEventsCount(filters).then((res) => {
      setEventsCount(res.count);
    });
  }, [session, paginatorInfo]);

  useEffect(() => {
    const session = State.session;
    if (!session) return;
    eventBackend
      .getEventCards(session.id, State.eventListRequestParams)
      .then((res) => {
        setEventCards(res.events);
      })
      .catch((e) => {
        toast("Не удалось загрузить события");
      });
    const { offset, limit, ...filterForCount } = State.eventListRequestParams;
    eventBackend.getAllEventsCount(filterForCount).then((res) => {
      setEventsCount(res.count);
    });
  }, [State.selectedItem, State.eventListRequestParams]);

  const handleOpenModal = () => {
    dispatch(
      openModal({
        component: CreateEventModal,
        context: {
          fixedCustomerId: data.id,
          defaultCustomerId: data.id,
          defaultResponsibleId: data.responsible?.id || data?.users?.length > 0 ? data.users[0]?.user_id || session?.id : session?.id,
          onSave: () => {
            dispatch(actions.selectItem(generateRandomString(4)));
          },
          closeModal: () => dispatch(closeModal()),
        },
      })
    );
  };

  const handleApplyPage: PaginatorCallback = (data) => {
    setPaginatorInfo(data)
  };

  return (
    <div className="columnCenter panelColumn2">
      <div className="panel eventListPanel">
        <div className="columnCenter">
          <div className="flex between w100">
            <PanelSubHeading text="История" />
            <div className="panelBtnContainer">
              <div className="btn panelActionBtn" onClick={handleOpenModal}>
                + Добавить событие
              </div>
            </div>
          </div>
          <div className="toDoHeadingBorder" />
          <div className="toDoHeading">Что нужно сделать</div>
          {eventCards.map((event: EventCardInfo, index) => {
            return <EventListCard {...event} key={`hmpe${index}`} />;
          })}
          <div className="flex cardPaginator">
            {eventsCount > 5 && (
              <Paginator
                perPage={5}
                count={eventsCount}
                onDataChange={handleApplyPage}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientEventsPanel;
